import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, slDate, STATUS } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/SiteChrome";

export default function CoupleHome() {
  const [ws, setWs] = useState(null);
  const nav = useNavigate();
  const { logout } = useAuth();
  useEffect(() => {
    api.get("/manage/weddings").then((r) => {
      if (r.data.length === 1) nav(`/nadzorna-plosca/${r.data[0].id}`, { replace: true });
      else setWs(r.data);
    });
  }, [nav]);
  if (!ws) return <div className="min-h-screen grid place-items-center text-[#6C6560]">Nalaganje …</div>;
  return (
    <div className="max-w-3xl mx-auto px-4 py-10 space-y-8" data-testid="couple-home">
      <div className="flex justify-between items-center"><Logo /><button onClick={logout} className="text-sm underline" data-testid="couple-logout">Odjava</button></div>
      <h1 className="font-display text-4xl">Vajine poroke</h1>
      {ws.length === 0 && <p className="text-[#6C6560]">Ta račun še nima poroke. <Link to="/ustvari" className="underline">Ustvarita jo</Link>.</p>}
      {ws.map((w) => (
        <Link key={w.id} to={`/nadzorna-plosca/${w.id}`} className="card-lux p-6 block" data-testid="couple-wedding-link">
          <p className="font-display text-2xl">{w.title}</p>
          <p className="text-sm text-[#6C6560]">{slDate(w.wedding_date)} · {STATUS[w.status]}</p>
        </Link>
      ))}
    </div>
  );
}
